// extracted by mini-css-extract-plugin
export default {"cls1":"FilterTextField-Label_cls1__hL4ti","cls2":"FilterTextField-Label_cls2__zH7Nz FilterTextField-Label_cls1__hL4ti"};